import { RestrictedObject } from '../core/role';

export const hasRequiredRoles = (
  userRoles: string[],
  featureRoles: string[] = [],
) => {
  const result = featureRoles.some((frole) => userRoles.includes(frole));

  return result;
};

export const filterRequiredRoles = <T>(
  filtrable: RestrictedObject<T>[] = [],
  userRoles: string[] = [],
) => {
  const result = filtrable.filter(
    (filter) => !hasRequiredRoles(userRoles, filter.restrictedRoles),
  );

  return result;
};
